// extracted by mini-css-extract-plugin
export default {"input":"x8-z","button":"y8-z","selected":"z8-z","unavailable":"A8-z","oos":"B8-z","image":"C8-z","paperCutDisabledOverlay":"D8-z"};